type BriefCopyParams = {
    brandName: string | undefined;
    projectName: string | undefined;
    campaignName: string | undefined;
    brief: string | null | undefined;
    turnaround: string | null | undefined;
    audioUrl: string | null | undefined;
};

export const formatBriefDataToWhatsAppMarkdown = ({
    brandName,
    projectName,
    campaignName,
    brief,
    turnaround,
    audioUrl,
}: BriefCopyParams) => {
    const header = `*📣  ${projectName} - ${brandName}*\n_${campaignName}_\n\n`;
    const formattedBrief = `*Brief:*\n${brief ? brief : ''}\n\n`;
    const formattedTurnaround = turnaround ? `*Turnaround*: ${turnaround}` : '';

    const songUrl = audioUrl ? `🎵  ${audioUrl}\n\n` : '';
    return `${header}${songUrl}${formattedBrief}${formattedTurnaround}`;
};
